import { render, staticRenderFns } from "./orderVideo.vue?vue&type=template&id=612be6f2&scoped=true&lang=pug&"
import script from "./orderVideo.vue?vue&type=script&lang=js&"
export * from "./orderVideo.vue?vue&type=script&lang=js&"
import style0 from "./orderVideo.vue?vue&type=style&index=0&id=612be6f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612be6f2",
  null
  
)

export default component.exports